module.exports = __webpack_public_path__ + "img/football-icon-red.9b9c7a2c.png";